import script from "./TradingAccountView.vue?vue&type=script&setup=true&lang=js"
export * from "./TradingAccountView.vue?vue&type=script&setup=true&lang=js"

import "./TradingAccountView.vue?vue&type=style&index=0&id=21c24d42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21c24d42"]])

export default __exports__